import { render, staticRenderFns } from "./LfCustomContextMenu.vue?vue&type=template&id=cd2b4a1e&scoped=true"
import script from "./LfCustomContextMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./LfCustomContextMenu.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LfCustomContextMenu.vue?vue&type=style&index=0&id=cd2b4a1e&lang=scss&scoped=true"
import style1 from "./LfCustomContextMenu.vue?vue&type=style&index=1&id=cd2b4a1e&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2b4a1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd2b4a1e')) {
      api.createRecord('cd2b4a1e', component.options)
    } else {
      api.reload('cd2b4a1e', component.options)
    }
    module.hot.accept("./LfCustomContextMenu.vue?vue&type=template&id=cd2b4a1e&scoped=true", function () {
      api.rerender('cd2b4a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomContextMenu/LfCustomContextMenu.vue"
export default component.exports